// extracted by mini-css-extract-plugin
module.exports = {"root":"IntegrationsPage_root__1Dq1t","body":"IntegrationsPage_body__3xVNQ"};